import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Pose2D extends Primitive {
    position;
    orientation;
    constructor(position, orientation) {
        super(Type.Pose2D);
        this.position = position;
        this.orientation = orientation;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9zZTJELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8yZC9Qb3NlMkQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBSTlCLE1BQU0sT0FBTyxNQUFPLFNBQVEsU0FBUztJQUMxQixRQUFRLENBQVM7SUFDakIsV0FBVyxDQUFRO0lBRTVCLFlBQVksUUFBaUIsRUFBRSxXQUFtQjtRQUNoRCxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQ2xCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFBO1FBQ3hCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFBO0lBQ2hDLENBQUM7Q0FDRiJ9